module.exports = __webpack_public_path__ + "arrowright_command.ff7500be2968f451aa80.svg";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/assets/images/arrowright_command.svg
// module id = ../../../../../src/assets/images/arrowright_command.svg
// module chunks = 2